import { Grid, Typography } from '@mui/material';
import React, { useState } from 'react';

import { TimeInput } from './TimeInput';
import { OpeningHour } from '@m4a3/api-client/dist/models/shared/opening-hours.interface';

interface OpeningHourInputGroupProps {
  onChange:  (dayOfWeek: number, hours: {startTime: string, endTime: string}) => void;
  opening: OpeningHour;
  dayIndex: number;
  timezone: string;
}
export const OpeningHourInputGroup = (props: OpeningHourInputGroupProps) => {
  const [startTime, setStartTime] = useState(props.opening?.startTime);
  const [endTime, setEndTime] = useState(props.opening?.endTime);

  const onChangeStart = (e: string) => {
    setStartTime(e);
    props.onChange(props.dayIndex, Object.assign({}, props.opening, {
      startTime: e,
      endTime: endTime,
    }));
  };

  const onChangeEnd = (e: string) => {
    setEndTime(e);
    props.onChange(props.dayIndex, Object.assign({}, props.opening, {
      startTime: startTime,
      endTime: e,
    }));
  };
  return (
    <Grid container spacing={2} marginY={1}>
      <Grid container alignItems="center" item xs={3}>
        <Typography>{props.opening?.dow}</Typography>
      </Grid>
      <Grid item xs={4}>
        <TimeInput label='Start' timeString={startTime} onTimeChanged={onChangeStart}/>
      </Grid>
      <Grid item xs={4}>
        <TimeInput label='End' timeString={endTime} onTimeChanged={onChangeEnd}/>
      </Grid>
    </Grid>
  );
};
